<template>
  <div class="page">
    <Panel
      lineColor="var(--primary-color)"
      style="margin-bottom: 0px; display: flex;"
      class="text-start"
    >
      <v-row no-gutters>
        <h4>Dados do Cliente</h4>
        <v-spacer />
        <v-icon v-if="panelActive == 'cliente'" @click="panelActive = ''">
          fa-chevron-up
        </v-icon>
        <v-icon v-else @click="panelActive = 'cliente'">
          fa-edit
        </v-icon>
      </v-row>
      <LineDivider
        v-if="
          panelActive == 'cliente' ||
            formCabecalho.cliente ||
            $v.formCabecalho.$error
        "
      />
      <v-alert v-if="$v.formCabecalho.$error" type="error" class="mb-4">
        Verifique os dados desta sessão, pois podem haver um ou mais dados
        inválidos
      </v-alert>
      <template v-if="panelActive != 'cliente'">
        <span v-if="formCabecalho.cliente">
          {{ formCabecalho.cliente.nome }} - CPF
          {{ formCabecalho.cliente.cpf }}
        </span>
      </template>
      <template v-else>
        <SelectCliente
          class="mb-n4"
          :class="$v.formCabecalho.$error ? 'mt-8' : ''"
          placeholder="Pesquisar pelo nome, cpf ou cnpj"
          label="Cliente"
          v-model="formCabecalho.cliente"
          :endpoint="endpointClient"
          queryname="filtro"
          keyid="idcadastroextracliente"
          keyvalue="nome"
          :multiple="false"
          :clearable="true"
          @change="selecionaCliente"
          :loading="isLoading"
          :validation="$v.formCabecalho.cliente"
        >
          <template v-slot:item="{ item }">
            <div class="d-flex flex-column align-start">
              <p style="margin-bottom:0!important">{{ item.nome_option }}</p>
              <small v-if="item.cpf"> CPF/CNPJ: {{ item.cpf }} </small>
            </div>
          </template>
        </SelectCliente>
        <v-row>
          <v-col>
            <FormAutocomplete
              label="Selecione uma forma de pagamento"
              v-model="formCabecalho.formaPagamento"
              @change="changePaymentMethod"
              :options="formaPagamento"
              class="mt-3"
              :loading="isLoading"
              :disabled="!formCabecalho.cliente"
              :validation="$v.formCabecalho.formaPagamento"
              chips
            />
          </v-col>
          <v-col v-if="permiteParcelamento">
            <FormSelect
              class="mt-3"
              label="Parcelamento"
              v-model="formCabecalho.parcelas"
              @blur="changeParcela"
              :options="optionParcelas"
              :disabled="isDisabled"
              :loading="isLoading"
              :validation="$v.formCabecalho.parcelas"
            />
          </v-col>
        </v-row>
        <FormSelect
          label="Tipo de entrega"
          v-model="formCabecalho.tipo_entrega"
          :options="opcoesFormaEntrega"
          :disabled="isDisabled"
          :loading="isLoading"
          @change="changeDeliveryType()"
          :validation="$v.formCabecalho.tipo_entrega"
        />
      </template>
    </Panel>
    <Panel
      lineColor="var(--primary-color)"
      style="margin-bottom: 0px; display: flex;"
      class="text-start mt-5"
    >
      <v-row no-gutters>
        <h4>Produtos</h4>
        <v-spacer />
        <v-icon v-if="panelActive == 'produto'" @click="panelActive = ''">
          fa-chevron-up
        </v-icon>
        <v-icon v-else @click="panelActive = 'produto'">
          fa-edit
        </v-icon>
      </v-row>
      <LineDivider
        v-if="
          panelActive == 'produto' ||
            countProdutos > 0 ||
            $v.formProdutos.$error
        "
      />
      <v-alert v-if="$v.formProdutos.$error" type="error" class="mb-4">
        Verifique os dados desta sessão, pois podem haver um ou mais dados
        inválidos
      </v-alert>
      <template v-if="panelActive != 'produto'">
        <span v-if="countProdutos > 0">
          {{ formProdutos[0].nome }}
          {{ counMoreProdutos }}
        </span>
      </template>
      <template v-else>
        <NovoPedidoProdutos
          v-model="formProdutos"
          :searchoption="productSearchOptions"
          :disabled="isDisabled"
          :limparproduto="limparProduto"
          :loading="isLoading"
        />
      </template>
    </Panel>
    <Panel
      lineColor="var(--primary-color)"
      class="text-start mt-5"
      style="margin-bottom: 0px;"
      v-if="formCabecalho.tipo_entrega !== 'RETIRADA'"
    >
      <v-row no-gutters>
        <h4>Endereço de Entrega</h4>
        <v-spacer />
        <v-icon
          v-if="panelActive === 'endereco_entrega'"
          @click="panelActive = ''"
        >
          fa-chevron-up
        </v-icon>
        <v-icon v-else @click="panelActive = 'endereco_entrega'">
          fa-edit
        </v-icon>
      </v-row>
      <LineDivider
        v-if="
          panelActive === 'endereco_entrega' ||
            formEnderecoEntrega.cep ||
            coordenadasErro ||
            $v.formEnderecoEntrega.$error
        "
      />
      <v-alert v-if="$v.formEnderecoEntrega.$error" type="error" class="mb-4">
        Verifique os dados desta sessão, pois podem haver um ou mais dados
        inválidos
      </v-alert>
      <v-alert v-if="coordenadasErro" type="error" class="mb-4">
        Não foi possível encontrar as coordenadas deste endereço, verifique o
        nome da rua e cidade
      </v-alert>
      <template v-if="panelActive !== 'endereco_entrega'">
        <span v-if="formEnderecoEntrega.cep || formEnderecoEntrega.rua">
          {{ formEnderecoEntrega.cep }} - {{ formEnderecoEntrega.rua }}
        </span>
      </template>
      <template v-else>
        <FormButton
          class="d-flex mr-auto mb-5"
          v-if="exibirEnderecos"
          @click="exibirModalEndereco"
        >
          <v-icon size="15" class="mr-3">fa-list</v-icon>
          <small>Listar Endereços</small>
        </FormButton>
        <v-row>
          <v-col>
            <FormField
              label="CEP"
              v-model="formEnderecoEntrega.cep"
              :validation="$v.formEnderecoEntrega.cep"
              personalizedMessage="O cep do endereço de entrega é obrigatório"
              :disabled="isDisabled || usaEnderecoUnico"
              @input="maskCep"
            />
          </v-col>
          <v-col>
            <FormSelect
              label="Estado"
              v-model="formEnderecoEntrega.uf"
              :options="estados"
              :validation="$v.formEnderecoEntrega.uf"
              personalizedMessage="O estado do endereço de entrega é obrigatório"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
          <v-col>
            <FormField
              label="Cidade"
              v-model="formEnderecoEntrega.cidade"
              :validation="$v.formEnderecoEntrega.cidade"
              personalizedMessage="A cidade do endereço de entrega é obrigatória"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <FormField
              label="Bairro"
              v-model="formEnderecoEntrega.bairro"
              :validation="$v.formEnderecoEntrega.bairro"
              personalizedMessage="O bairro é obrigatório"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
          <v-col>
            <FormField
              label="Rua"
              v-model="formEnderecoEntrega.rua"
              :validation="$v.formEnderecoEntrega.rua"
              personalizedMessage="A rua é obrigatória"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
          <v-col>
            <FormField
              label="Número"
              v-model="formEnderecoEntrega.numero"
              :validation="$v.formEnderecoEntrega.numero"
              personalizedMessage="O número é obrigatório"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
        </v-row>
        <FormField
          label="Complemento"
          v-model="formEnderecoEntrega.complemento"
          :disabled="isDisabled || usaEnderecoUnico"
        />
      </template>
    </Panel>
    <Panel
      lineColor="var(--primary-color)"
      class="text-start mt-5"
      style="margin-bottom: 0px;"
      v-if="
        formaPagamentoSelecionada && formaPagamentoSelecionada.tipo === 'BOLETO'
      "
    >
      <v-row no-gutters>
        <h4>Endereço de Faturamento</h4>
        <v-spacer />
        <v-icon
          v-if="panelActive === 'endereco_faturamento'"
          @click="panelActive = ''"
        >
          fa-chevron-up
        </v-icon>
        <v-icon v-else @click="panelActive = 'endereco_faturamento'">
          fa-edit
        </v-icon>
      </v-row>
      <LineDivider
        v-if="
          panelActive === 'endereco_faturamento' ||
            formEnderecoFaturamento.cep ||
            $v.formEnderecoFaturamento.$error
        "
      />
      <v-alert
        v-if="$v.formEnderecoFaturamento.$error"
        type="error"
        class="mb-4"
      >
        Verifique os dados desta sessão, pois podem haver um ou mais dados
        inválidos.
      </v-alert>
      <template v-if="panelActive !== 'endereco_faturamento'">
        <span v-if="formEnderecoFaturamento.cep || formEnderecoFaturamento.rua">
          {{ formEnderecoFaturamento.cep }} - {{ formEnderecoFaturamento.rua }}
        </span>
      </template>
      <template v-else>
        <v-row>
          <v-col>
            <FormField
              label="CEP"
              v-model="formEnderecoFaturamento.cep"
              :validation="$v.formEnderecoFaturamento.cep"
              personalizedMessage="O cep do endereço de faturamento é obrigatório"
              :disabled="isDisabled"
            />
          </v-col>
          <v-col>
            <FormSelect
              label="Estado"
              v-model="formEnderecoFaturamento.uf"
              :options="estados"
              :validation="$v.formEnderecoFaturamento.uf"
              personalizedMessage="O estado do endereço de faturamento é obrigatório"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
          <v-col>
            <FormField
              label="Cidade"
              v-model="formEnderecoFaturamento.cidade"
              :validation="$v.formEnderecoFaturamento.cidade"
              personalizedMessage="A cidade do endereço de faturamento é obrigatória"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <FormField
              label="Bairro"
              v-model="formEnderecoFaturamento.bairro"
              :validation="$v.formEnderecoFaturamento.bairro"
              personalizedMessage="O bairro é obrigatório"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
          <v-col>
            <FormField
              label="Rua"
              v-model="formEnderecoFaturamento.rua"
              :validation="$v.formEnderecoFaturamento.rua"
              personalizedMessage="A rua é obrigatória"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
          <v-col>
            <FormField
              label="Número"
              v-model="formEnderecoFaturamento.numero"
              :validation="$v.formEnderecoFaturamento.numero"
              personalizedMessage="O número é obrigatório"
              :disabled="isDisabled || usaEnderecoUnico"
            />
          </v-col>
        </v-row>
        <FormField
          label="Complemento"
          v-model="formEnderecoFaturamento.complemento"
          :disabled="isDisabled || usaEnderecoUnico"
        />
        <FormButton
          class="d-flex ml-auto"
          @click="copiarEndereco"
          :disabled="isDisabled || usaEnderecoUnico"
        >
          Utilizar Endereço de Entrega
        </FormButton>
      </template>
    </Panel>
    <Panel lineColor="var(--primary-color)" class="text-start mt-5">
      <v-row no-gutters>
        <h4>Finalização</h4>
        <v-spacer />
        <v-icon v-if="panelActive === 'totais'" @click="panelActive = ''">
          fa-chevron-up
        </v-icon>
        <v-icon v-else @click="panelActive = 'totais'">
          fa-edit
        </v-icon>
      </v-row>
      <LineDivider v-if="panelActive === 'totais' || $v.formTotais.$error" />
      <v-alert v-if="$v.formTotais.$error" type="error" class="mb-4">
        Verifique os dados desta sessão, pois podem haver um ou mais dados
        inválidos
      </v-alert>
      <template v-if="panelActive !== 'totais'">
        <div>Total do pedido {{ totalPedido | formatMoney }}</div>
      </template>
      <template v-else>
        <template v-if="existeFormaDeEntrega">
          <h4>Opções de entrega</h4>
          <v-row>
            <v-col>
              <FormRadioGroup
                class="ma-0 mb-n5"
                v-model="formTotais.formaEntrega"
                :radios="formasEntrega"
                :validation="$v.formTotais.formaEntrega"
                personalizedMessage="A opção de entrega é obrigatória"
                @change="chageDeliveryType"
                :disabled="isDisabled"
              />
            </v-col>
          </v-row>
        </template>
        <FormField
          v-model="formCabecalho.codigocupom"
          label="Cupom de desconto"
          :disabled="isDisabled"
          @blur="validaCupom(true)"
          class="mt-3"
        />
        <FormText
          v-model="formCabecalho.observacoes"
          label="Observações"
          :disabled="isDisabled"
          rows="3"
          class="mt-3"
        />
        <h4>Totais</h4>
        <NovoPedidoProdutos
          v-model="formProdutos"
          :limparproduto="limparProduto"
          :onlyview="true"
        />
        <div class="mt-3">
          <v-row no-gutters v-for="(item, index) in totaisLista" :key="index">
            <v-spacer />
            <v-col cols="auto" class="font-weight-bold">{{ item.label }}</v-col>
            <v-col cols="2" class="text-end mr-5">{{
              item.valor | formatMoney
            }}</v-col>
          </v-row>
        </div>
        <LineDivider />
        <v-row class="footer-buttons mt-5">
          <v-spacer />
          <v-col cols="auto">
            <FormButton
              type="error"
              @click="cancelarPedido"
              :disabled="isLoading"
            >
              Cancelar
            </FormButton>
          </v-col>
          <v-col cols="auto">
            <FormButton type="primario" @click="onSubmit" :loading="isLoading">
              Enviar
            </FormButton>
          </v-col>
        </v-row>
      </template>
    </Panel>

    <v-dialog v-model="dialogEndereco" max-width="600px" persistent>
      <v-card>
        <v-card-title class="justify-center">
          <h3 class="font-bold">Endereços</h3>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="endereco in enderecos"
              :key="endereco.idendereco"
              @click="selecionarEndereco(endereco)"
              style="cursor: pointer;"
            >
              <v-list-item-content>
                <v-list-item-title>{{ endereco.descricao }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  endereco.textoendereco
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <FormButton type="error" @click="dialogEndereco = false">
            Fechar
          </FormButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNovoPedido" scrollable max-width="60%" persistent>
      <v-card v-if="novoPedido" max-height="80vh" class="text-start">
        <v-card-title>Pedido {{ novoPedido.numpedido }}</v-card-title>
        <v-divider />
        <v-card-text>
          <v-container>
            <h3 class="mb-3">Detalhes</h3>
            <v-simple-table dense class="mb-5">
              <tbody>
                <tr>
                  <td class="col-3">CPF:</td>
                  <td>{{ novoPedido.cliente_cpf }}</td>
                </tr>
                <tr>
                  <td class="col-3">Telefone:</td>
                  <td>
                    {{ novoPedido.cliente_telefone }}
                  </td>
                </tr>
                <tr>
                  <td class="col-3">Tipo de entrega:</td>
                  <td>{{ novoPedido.tipo_entrega }}</td>
                </tr>
                <tr>
                  <td class="col-3">Endereço de entrega:</td>
                  <td>
                    {{ novoPedido.dadospedido.enderecoentrega.textoendereco }}
                  </td>
                </tr>
                <tr>
                  <td class="col-3">Forma de entrega:</td>
                  <td>{{ novoPedido.forma_entrega.nome }}</td>
                </tr>
                <tr>
                  <td class="col-3">Status do pedido:</td>
                  <td>{{ statusNovoPedido }}</td>
                </tr>
                <tr>
                  <td class="col-3">Forma de pagamento:</td>
                  <td>
                    {{ novoPedido.dadospedido.formaPagamento.descricao }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <h3 class="mb-3">Itens</h3>
            <v-simple-table dense v-if="itensPedido">
              <thead>
                <tr>
                  <th>Nome do produto</th>
                  <th>Quantidade</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in itensPedido.filter(
                    item => item.tipo_produto !== 'CONJUNTO'
                  )"
                  :key="item.id"
                >
                  <td>
                    {{
                      item.idcombopromocional_cabecalho
                        ? item.nome_combo
                        : item.nome
                    }}
                  </td>
                  <td>
                    {{
                      item.multiploincremento
                        ? item.quantidade / item.multiploincremento
                        : item.quantidade
                    }}
                    {{ item.labelunidade }}
                  </td>
                  <td>
                    {{
                      ((item.precoatendente > 0
                        ? item.precoatendente
                        : item.preco) *
                        item.quantidade)
                        | formatMoney
                    }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-divider class="my-5" />
            <v-row no-gutters>
              <v-spacer />
              <v-col cols="auto" class="font-weight-bold">
                Valor produtos
              </v-col>
              <v-col cols="2" class="font-weight-bold text-end">
                {{ novoPedido.totalpedido | formatMoney }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-spacer />
              <v-col cols="auto" class="font-weight-bold">
                Descontos
              </v-col>
              <v-col cols="2" class="font-weight-bold text-end">
                {{ novoPedido.totaldesconto | formatMoney }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-spacer />
              <v-col cols="auto" class="font-weight-bold">
                Taxas
              </v-col>
              <v-col cols="2" class="font-weight-bold text-end">
                {{ novoPedido.taxaentrega | formatMoney }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-spacer />
              <v-col cols="auto" class="font-weight-bold">
                Valor Total
              </v-col>
              <v-col cols="2" class="font-weight-bold text-end">
                {{ novoPedido.totalliquido | formatMoney }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <FormButton
            type="primario"
            :loading="isLoading"
            @click="apagarNovoPedido"
          >
            Voltar
          </FormButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import LineDivider from "@/components/LineDivider";
import SelectCliente from "@/components/select/SelectCliente";
import FormAutocomplete from "@/components/form/FormAutocomplete";
import FormSelect from "@/components/form/FormSelect";
import FormField from "@/components/form/FormField";
import FormText from "@/components/form/FormText";
import FormButton from "@/components/form/FormButton";
import NovoPedidoProdutos from "./NovoPedidoProdutos";
import {
  obterTetoDescontoCupom,
  limitarDescontoAoTeto,
  calcularDescontoPercentualComTetoNasLinhas
} from "./cupom-desconto-teto-helpers";
import FormRadioGroup from "@/components/form/FormRadioGroup";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import io from "socket.io-client";
import * as _ from "lodash";
import { uuid } from "uuidv4";
import ApiWeb from "../../../service/api-web";
import {
  CLIENTE_LOAD_PAYMENT_METHODS,
  CLIENTE_LOAD_ADDRESS,
  CLIENTE_LOAD_ALL_ADDRESS
} from "@/store/actions/cliente";
import {
  VENDA_MAIS_LOAD_CART,
  VENDA_MAIS_COORDENADAS,
  VENDA_MAIS_FORMAS_ENTREGA,
  VENDA_MAIS_ENVIAR,
  VENDA_MAIS_VALIDAR_CUPOM,
  VENDA_MAIS_LOAD_CLIENTE
} from "@/store/actions/vendaMais";
import { ModulesEnum } from "@/store/actions/modulesEnum";

export default {
  name: "InicioAdmin",
  components: {
    Panel,
    LineDivider,
    SelectCliente,
    FormAutocomplete,
    FormSelect,
    NovoPedidoProdutos,
    FormField,
    FormButton,
    FormText,
    FormRadioGroup
  },
  data: () => ({
    socketUrl: null,
    chatsocket: null,
    dialogNovoPedido: false,
    dialogEndereco: false,
    isLoading: false,
    panelActive: "cliente",
    formCabecalho: {
      cliente: null,
      formaPagamento: null,
      parcelas: 1,
      tipo_entrega: "DELIVERY",
      cupom: null,
      codigocupom: "",
      observacoes: ""
    },
    enderecos: [],
    formEnderecoEntrega: {},
    formEnderecoFaturamento: {},
    formProdutos: [],
    formTotais: {
      formaEntrega: null
    },
    estados: [
      { text: "Acre", value: "AC" },
      { text: "Alagoas", value: "AL" },
      { text: "Amapá", value: "AP" },
      { text: "Amazonas", value: "AM" },
      { text: "Bahia", value: "BA" },
      { text: "Ceará", value: "CE" },
      { text: "Distrito Federal", value: "DF" },
      { text: "Espírito Santo", value: "ES" },
      { text: "Goiás", value: "GO" },
      { text: "Maranhão", value: "MA" },
      { text: "Mato Grosso", value: "MT" },
      { text: "Mato Grosso do Sul", value: "MS" },
      { text: "Minas Gerais", value: "MG" },
      { text: "Pará", value: "PA" },
      { text: "Paraíba", value: "PB" },
      { text: "Paraná", value: "PR" },
      { text: "Pernambuco", value: "PE" },
      { text: "Piauí", value: "PI" },
      { text: "Rio de Janeiro", value: "RJ" },
      { text: "Rio Grande do Norte", value: "RN" },
      { text: "Rio Grande do Sul", value: "RS" },
      { text: "Rondônia", value: "RO" },
      { text: "Roraima", value: "RR" },
      { text: "Santa Catarina", value: "SC" },
      { text: "São Paulo", value: "SP" },
      { text: "Sergipe", value: "SE" },
      { text: "Tocantins", value: "TO" }
    ],
    formaPagamento: [],
    formasEntrega: [],
    coordenadasErro: false,
    token: uuid(),
    tokenSplit: "cc64548c0cbad6cf58d4d3bbd433142b",
    novoPedido: {
      numpedido: 12345,
      cliente_cpf: "123.456.789-00",
      cliente_telefone: "(11) 98765-4321",
      tipo_entrega: "Entrega Rápida",
      dadospedido: {
        enderecoentrega: {
          textoendereco: "Rua das Flores, 123 - São Paulo, SP"
        },
        formaPagamento: {
          descricao: "Cartão de Crédito"
        }
      },
      forma_entrega: {
        nome: "Motoboy"
      },
      totalpedido: 150.5, // Valor total dos produtos
      totaldesconto: 10.0, // Total de descontos aplicados
      taxaentrega: 5.0, // Valor da taxa de entrega
      totalliquido: 145.5 // Valor total com descontos e taxas aplicados
    },
    cpfCliente: "",
    limparProduto: false
  }),
  validations: {
    formCabecalho: {
      cliente: {
        required
      },
      formaPagamento: {
        required
      },
      parcelas: {
        required
      },
      tipo_entrega: {
        required
      }
    },
    formEnderecoEntrega: {
      cep: {
        required
      },
      uf: {
        required
      },
      cidade: {
        required
      },
      bairro: {
        required
      },
      rua: {
        required
      },
      numero: {
        required
      }
    },
    formEnderecoFaturamento: {
      cep: {
        required
      },
      uf: {
        required
      },
      cidade: {
        required
      },
      bairro: {
        required
      },
      rua: {
        required
      },
      numero: {
        required
      }
    },
    formProdutos: {
      required
    },
    formTotais: {
      formaEntrega: {
        required
      }
    }
  },
  watch: {
    getFornecedorId: function(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.resetaFormChangeCliente(true, true);
      }
    },
    formProdutos: function(newValue, oldValue) {
      if (newValue.length && newValue.length !== oldValue.length) {
        this.validaCupom(false);
      }
    },
    "formCabecalho.cupom": function() {
      this.updateProdutoDesconto();
    },
    panelActive: function() {
      if (this.panelActive == "totais") {
        if (this.formCabecalho.tipo_entrega === "DELIVERY") {
          this.buscaCoordenadas();
        } else {
          this.buscaFormasEntrega();
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "getFornecedorId",
      "getFornecedorTag",
      "moduloFornecedorAtivo"
    ]),
    usesSingleAddressForClientCpf() {
      return this.getFornecedorTag["uses-single-address-for-client-cpf"];
    },
    usesSingleAddressForClient() {
      return this.getFornecedorTag["uses-single-address-for-client"];
    },
    hasCollect() {
      return this.getFornecedorTag["has-collect"];
    },
    hasDelivery() {
      return this.getFornecedorTag["has-delivery"];
    },
    endpointClient() {
      return `/api/v4/client/list/vendamais?idfornecedor=${this.getFornecedorId}`;
    },
    opcoesFormaEntrega() {
      const opcoes = [];
      if (this.hasCollect) {
        opcoes.push({
          value: "RETIRADA",
          text: "Retirada - o cliente vem buscar"
        });
      }
      if (this.hasDelivery) {
        opcoes.push({ value: "DELIVERY", text: "Delivery - vou entregar" });
      }
      return opcoes;
    },
    productSearchOptions() {
      if (this.formCabecalho.cliente && this.formaPagamentoSelecionada) {
        return {
          idformapagamento: this.formaPagamentoSelecionada.idformapagto,
          idcliente: this.formCabecalho.cliente.idcliente,
          tipoEntrega: this.formCabecalho.tipo_entrega
        };
      }

      return {
        idformapagamento: "",
        idcliente: "",
        tipoEntrega: ""
      };
    },
    casasDecimais() {
      return _.get(this.formProdutos, "[0].meta_info.quantidadeDecimais", 2);
    },
    totalProdutos() {
      let total =
        this.totalProdutosSemDesconto -
        (this.cupomEmProduto ? 0 : this.descontoCupom);
      return total > 0 ? total : 0;
    },
    totalProdutosSemDesconto() {
      return (this.formProdutos || []).reduce((total, produto) => {
        const precoAtendente = Number(produto.precoatendente);
        const useAtendente =
          precoAtendente > 0 && !this.isAtendenteEqualPreco(produto);
        total +=
          Number(useAtendente ? precoAtendente : produto.preco) *
            Number(produto.quantidade || 1) -
          Number(produto.preco_do_desconto || 0);
        return total;
      }, 0);
    },
    totalProdutoSemCupom() {
      return (this.formProdutos || []).reduce(
        (valor, produto) => valor + produto.preco * produto.quantidade,
        0
      );
    },
    totalTaxas() {
      if (this.formTotais.formaEntrega) {
        const find = this.findFormaEntrega(this.formTotais.formaEntrega);
        return find ? find.custo : 0;
      }
      return 0;
    },
    totalPedido() {
      let total =
        this.totalProdutosSemDesconto +
        this.totalTaxas -
        (this.cupomEmProduto ? 0 : this.descontoCupom);
      return total > 0 ? total : 0;
    },
    descontoCupom() {
      if (this.formCabecalho.cupom) {
        const {
          tipoDesconto,
          valorDescontoPercentual,
          totalDescontoEspecifico,
          produtosComDesconto
        } = this.formCabecalho.cupom;

        let totalDesconto = 0;
        if ((produtosComDesconto || []).length) {
          totalDesconto = totalDescontoEspecifico;
        } else {
          const isPercent = tipoDesconto === "%";
          totalDesconto = isPercent
            ? this.totalProdutosSemDesconto *
              ((valorDescontoPercentual || 0) / 100)
            : valorDescontoPercentual;
          if (isPercent) {
            const tetoDesconto = obterTetoDescontoCupom(this.formCabecalho.cupom);
            totalDesconto = limitarDescontoAoTeto(totalDesconto, tetoDesconto);
          }
          if (!isPercent && totalDesconto > this.totalProdutosSemDesconto) {
            totalDesconto = this.totalProdutosSemDesconto;
          }
        }

        return totalDesconto;
      }
      return 0;
    },
    cupomEmProduto() {
      if (this.formCabecalho.cupom) {
        const { totalDescontoEspecifico } = this.formCabecalho.cupom;

        return totalDescontoEspecifico && totalDescontoEspecifico > 0;
      }
      return false;
    },
    countProdutos() {
      return (this.formProdutos || []).length || 0;
    },
    counMoreProdutos() {
      return this.countProdutos > 1 ? `e mais ${this.countProdutos - 1}` : "";
    },
    isDisabled() {
      return !this.formCabecalho.cliente || !this.formaPagamentoSelecionada;
    },
    usaEnderecoEntrega() {
      return this.formCabecalho.tipo_entrega !== "RETIRADA";
    },
    usaEnderecoFaturamento() {
      return (
        this.formaPagamentoSelecionada &&
        this.formaPagamentoSelecionada.tipo === "BOLETO"
      );
    },
    resourceActived() {
      return this.showComponente([ModulesEnum.VENDAMAIS_WEB]);
    },
    usaEnderecoUnico() {
      if (!this.formCabecalho.cliente) {
        return false;
      }
      if (this.formCabecalho.cliente.cpf.length === 11) {
        return (
          this.usesSingleAddressForClientCpf ||
          this.formCabecalho.cliente.tag.includes("uses-single-address")
        );
      } else {
        return (
          this.usesSingleAddressForClient ||
          this.formCabecalho.cliente.tag.includes("uses-single-address")
        );
      }
    },
    permiteParcelamento() {
      if (!this.isDisabled) {
        return _.get(
          this.formaPagamentoSelecionada,
          "permite_parcelamento",
          false
        );
      }
      return false;
    },
    formaPagamentoSelecionada() {
      return (this.formaPagamento || []).filter(
        fp => fp.idformapagto == this.formCabecalho.formaPagamento
      )[0];
    },
    maximoParcela() {
      return _.get(this.formaPagamentoSelecionada, "quant_maxima_parcelas", 1);
    },
    optionParcelas() {
      return Array.from(Array(this.maximoParcela).keys()).map(p => {
        return {
          value: p + 1,
          text: `${p + 1}X - R$ ${(this.totalPedido / (p + 1)).toFixed(2)}`
        };
      });
    },
    exibirEnderecos() {
      return this.enderecos.length !== 0;
    },
    existeFormaDeEntrega() {
      return this.formasEntrega.length !== 0;
    },
    statusNovoPedido() {
      if (!this.novoPedido) {
        return "";
      }
      switch (this.novoPedido.statuspedido) {
        case "ORCAMENTO_NOVO":
          return "Em análise";
        case "ORCAMENTO_PRECIFICADO":
          return "Orçado";
        case "ENVIADO":
          return "Pedido recebido";
        case "SEPARANDO":
          return "Preparando seu pedido";
        case "AGUARDANDOPAGAMENTO":
          return "Aguardando pagamento";
        case "PAGO":
          return "Pedido pronto para entrega";
        case "PRONTO_RETIRADA":
          return "Pronto para retirada";
        case "EMENTREGA":
          return "Pedido saiu para entrega";
        case "ENTREGUE":
          return "Pedido entregue";
        case "CANCELADO":
          return "Cancelado";
        case "EM_ANALISE":
          return "Em Análise";
        default:
          return "";
      }
    },
    itensPedido() {
      const itens = _.get(this.novoPedido, "dadospedido.itens", []);
      const itensFormatCombo = _.get(
        this.novoPedido,
        "dadospedido.itensFormatCombo",
        []
      );
      if (!itens.length && !itensFormatCombo.length) {
        return null;
      }
      return itensFormatCombo.length ? itensFormatCombo : itens;
    },
    totaisLista() {
      return [
        { label: "Total em produtos", valor: this.totalProdutos },
        {
          label: "Total original (sem desconto)",
          valor: this.totalProdutoSemCupom
        },
        { label: "Desconto do cupom", valor: this.descontoCupom },
        { label: "Total em taxas", valor: this.totalTaxas },
        { label: "Total do pedido", valor: this.totalPedido }
      ];
    }
  },
  methods: {
    getUrlSocket() {
      ApiWeb.v4.chat
        .getUrl()
        .then(resp => {
          const { socketUrl } = resp.data;
          if (!socketUrl) {
            this.$vueOnToast.pop(
              "error",
              "Erro ao buscar configuração do Socket"
            );
          } else {
            this.socketUrl = socketUrl;
          }
        })
        .catch(err => {
          this.$vueOnToast.pop("error", err);
        });
    },
    isAtendenteEqualPreco(produto) {
      const precoatendente = produto.precoatendente;
      const preco = produto.preco;
      if (!precoatendente || !preco) {
        return true;
      }

      return (
        Number(precoatendente) ===
        Number(preco.toFixed(this.casasDecimais || 2))
      );
    },
    sendAcesso() {
      ApiWeb.v4.vendamais.acesso();
    },
    getCliente(busca) {
      if (busca) {
        this.isLoading = true;
        this.$store
          .dispatch(VENDA_MAIS_LOAD_CLIENTE, busca)
          .then(data => {
            const item = data[0];
            if (item) {
              this.formCabecalho.cliente = {
                ...item,
                value: item.idcliente,
                id: item.idcliente,
                text: item.nome
              };
              this.selecionaCliente();
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao buscar usuário");
            this.isLoading = false;
          });
      }
    },
    copiarEndereco() {
      this.formEnderecoFaturamento = this.formEnderecoEntrega;
    },
    onSubmit() {
      if (
        this.formaPagamentoSelecionada &&
        this.formaPagamentoSelecionada.tipo === "BOLETO"
      ) {
        this.$v.formEnderecoFaturamento.$touch();
        if (this.$v.formEnderecoFaturamento.$invalid) return;
      }

      this.$v.formCabecalho.$touch();
      this.$v.formProdutos.$touch();

      if (this.$v.formCabecalho.$invalid || this.$v.formProdutos.$invalid) {
        return;
      }

      if (!this.resourceActived) {
        this.$vueOnToast.pop(
          "error",
          "Este recurso não está habilidato para este fornecedor!"
        );
        return;
      }

      this.$v.formTotais.$touch();
      if (this.$v.formTotais.$invalid) {
        return;
      }

      if (this.formCabecalho.tipo_entrega === "DELIVERY") {
        this.$v.formEnderecoEntrega.$touch();
        if (this.$v.formEnderecoEntrega.$invalid) {
          return;
        }

        if (this.coordenadasErro) {
          this.$vueOnToast.pop(
            "error",
            "Não é possivel enviar um pedido cujo as coordenadas não foram encontradas"
          );
          return;
        }

        this.formEnderecoEntrega.cep = this.formEnderecoEntrega.cep.replace(
          "-",
          ""
        );
        const cep = this.formEnderecoEntrega.cep;

        if (cep.length > 8 || cep.length < 8) {
          this.isLoading = false;
          this.$vueOnToast.pop(
            "warning",
            "Erro ao tentar salvar um endereço: CEP inválido. Nenhuma ação foi executada."
          );
          return;
        }
      }

      this.isLoading = true;

      let pedido = {
        precoManual: true,
        idcliente: _.get(this.formCabecalho, "cliente.idcliente", ""),
        caracteristicas: _.get(
          this.formCabecalho,
          "cliente.caracteristicas",
          []
        ),
        itens: (this.formProdutos || [])
          .filter(produto => produto.quantidade > 0)
          .map(produto => {
            const quantidade = Number(produto.quantidade) || 1;
            const recomendacao = produto.recomendacao || null;
            const preco_embalagem = produto.embalarParaPresente
              ? produto.preco_embalagem
              : null;
            const precoatendente = this.isAtendenteEqualPreco(produto)
              ? null
              : produto.precoatendente;

            return {
              id: produto.id,
              id_produto_erp: produto.id_produto_erp,
              idcadastroextra: produto.idcadastroextraproduto,
              idproduto: produto.idproduto,
              nome: produto.nome,
              preco: Number(produto.preco),
              preconf: Number(produto.preconf),
              unidade: produto.unidade,
              quantidade,
              tipo_produto: produto.tipo_produto,
              precoatendente,
              preco_embalagem,
              preco_do_desconto: produto.preco_do_desconto,
              preco_original: produto.preco_original,
              precovendaatacado: produto.precovendaatacado,
              preco_sem_politica_varejo: produto.preco_sem_politica_varejo,
              preco_sem_politica_atacado: produto.preco_sem_politica_atacado,
              embalarParaPresente: produto.embalarParaPresente,
              recomendacao,
              meta_info: produto.meta_info || {},
              multiploincremento: produto.multiploincremento,
              id_combo_item: produto.id_combo_item || null
            };
          }),
        anotacoes: this.formCabecalho.observacoes,
        cupom: this.formCabecalho.codigocupom,
        tipoEntrega: this.formCabecalho.tipo_entrega,
        formaEntrega: this.findFormaEntrega(this.formTotais.formaEntrega) || "",
        enderecofaturamento: {
          ...this.formEnderecoFaturamento
        },
        enderecoentrega: {
          ...this.formEnderecoEntrega,
          coords: {
            lat: _.get(this.formEnderecoEntrega, "lat"),
            lng: _.get(this.formEnderecoEntrega, "lng")
          }
        },
        formaPagamento: {
          idformapagto: _.get(this.formCabecalho, "formaPagamento", ""),
          quant_parcelas: _.get(this.formCabecalho, "parcelas", 1)
        }
      };

      this.$store
        .dispatch(VENDA_MAIS_ENVIAR, pedido)
        .then(resp => {
          if (resp.mensagemErro) {
            this.$vueOnToast.pop("error", resp.mensagemErro);
          } else {
            this.novoPedido = {
              ...resp,
              cliente_cpf: this.formCabecalho.cliente.cpf,
              cliente_telefone: this.formCabecalho.cliente.telefone
            };
            this.dialogNovoPedido = true;
            this.$vueOnToast.pop(
              "success",
              `Pedido enviado! Nº${resp.numpedido}`
            );
            this.resetaFormChangeCliente(true, true);
            this.panelActive = "cliente";
            this.chatsocket.emit("submit-order", resp.numpedido);
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          const erro =
            err.error.mensagemErro ||
            err.error.message ||
            "Falha ao submeter pedido";
          this.$vueOnToast.pop("error", erro);
        });
    },
    selecionaCliente() {
      const idcliente = this.formCabecalho
        ? this.formCabecalho?.cliente?.idcliente
        : "";

      this.resetaFormChangeCliente(false, true);
      if (!this.formCabecalho.cliente) {
        return;
      }
      this.getPaymentMethods(idcliente);

      if (!this.usaEnderecoUnico) {
        this.getAllAddress(idcliente);
      } else {
        this.enderecos = [];
      }

      this.getAddress(idcliente);
      this.initConnectionSocket(idcliente);
    },
    getPaymentMethods(idcliente) {
      this.isLoading = true;
      this.$store
        .dispatch(CLIENTE_LOAD_PAYMENT_METHODS, idcliente)
        .then(data => {
          this.formaPagamento = data.map(f => {
            return {
              ...f,
              text: f.descricao,
              value: f.idformapagto
            };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getAllAddress(idcliente) {
      this.isLoading = true;
      const data = {
        idcliente: idcliente,
        token: this.token,
        tokenSplit: this.tokenSplit
      };
      this.$store
        .dispatch(CLIENTE_LOAD_ALL_ADDRESS, data)
        .then(data => {
          this.enderecos = data.map(e => {
            return {
              ...e,
              text: e.descricao,
              value: e.idendereco
            };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getAddress(idcliente) {
      this.isLoading = true;
      this.$store
        .dispatch(CLIENTE_LOAD_ADDRESS, idcliente)
        .then(data => {
          if (data.endereco_primario) {
            this.formEnderecoEntrega = {
              ...data.endereco_primario,
              numero: _.get(data, "endereco_primario.numero", "s/n") || "s/n"
            };
          }
          if (data.endereco_faturamento) {
            this.formEnderecoFaturamento = {
              ...data.endereco_faturamento,
              numero: _.get(data, "endereco_faturamento.numero", "s/n") || "s/n"
            };
          }
          this.chatsocket.emit("block-cart", true);
          this.chatsocket.emit(
            "change-delivery-address",
            data.endereco_primario
          );
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    changePaymentMethod(idformapagto) {
      const formaDePagamentoSelecionada = this.formaPagamento.find(
        formPag => formPag.idformapagto === idformapagto
      );

      if (formaDePagamentoSelecionada) {
        this.resetaFormChangeCliente(false, false, idformapagto);
        this.chatsocket.emit("block-cart", true);
        this.chatsocket.emit("change-payment", formaDePagamentoSelecionada);
      }
    },
    changeParcela(parcelas) {
      this.chatsocket.emit("block-cart", true);
      this.chatsocket.emit("change-payment", {
        ...this.formaPagamentoSelecionada,
        quant_parcelas: parcelas
      });
    },
    changeDeliveryType() {
      this.chatsocket.emit("block-cart", true);
      this.chatsocket.emit(
        "change-delivery-type",
        this.formCabecalho.tipo_entrega
      );

      this.limparProduto = true;
      this.$v.formEnderecoEntrega.$reset();
      this.$v.formEnderecoFaturamento.$reset();
      this.$v.formProdutos.$reset();
      this.$v.formTotais.$reset();
      this.buscarCarrinho();
    },
    resetaFormChangeCliente(
      resetCliente = false,
      resetFormaPagamento = false,
      idformapagamento
    ) {
      const { cliente, formaPagamento } = this.formCabecalho;
      this.formCabecalho = {
        cliente: resetCliente ? null : cliente,
        formaPagamento: resetFormaPagamento ? null : formaPagamento,
        parcelas: 1,
        tipo_entrega: "DELIVERY",
        cupom: null,
        codigocupom: "",
        observacoes: ""
      };
      if (resetCliente) {
        this.formEnderecoEntrega = this.buscarNovoEndereco();
        this.formEnderecoFaturamento = this.buscarNovoEndereco();
        this.formProdutos = [];
      }
      this.formTotais = { formaEntrega: null };
      this.$v.$reset();
      this.buscarCarrinho(idformapagamento);
    },
    buscarNovoEndereco() {
      return {
        cep: "",
        uf: "",
        cidade: "",
        bairro: "",
        rua: "",
        numero: "",
        complemento: "",
        lat: "",
        lng: ""
      };
    },
    buscarCarrinho(idformapagamento) {
      this.isLoading = true;
      const data = {
        token: this.token,
        idcliente: _.get(this.formCabecalho, "cliente.idcliente", ""),
        idformapagamento:
          idformapagamento ||
          _.get(this.formCabecalho, "formaPagamento", "") ||
          "",
        idtipoassinatura: "",
        tipoEntrega: _.get(this.formCabecalho, "tipo_entrega", ""),
        vendaMais: true
      };
      this.$store
        .dispatch(VENDA_MAIS_LOAD_CART, data)
        .then(data => {
          if (data.status === "success") {
            data.dados.forEach(d => {
              const preco = _.get(d, "preco", 0);
              const precoAtendente = Number(_.get(d, "precoatendente", preco));
              d.precoatendente = precoAtendente.toFixed(2);
              d._precoOriginal = d.precoatendente;
              d._quantidadeOriginal = d.quantidade;
            });
            this.formProdutos = data.dados.filter(prod => prod.quantidade > 0);
          } else {
            this.formProdutos = [];
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    selecionarEndereco(end) {
      this.formEnderecoEntrega = end;
      this.maskCep(end);
      this.dialogEndereco = false;
      this.chatsocket.emit("block-cart", true);
      this.chatsocket.emit("change-delivery-address", end);
    },
    buscaCoordenadas() {
      if (
        this.formCabecalho.tipo_entrega === "DELIVERY" &&
        this.formEnderecoEntrega &&
        !this.formEnderecoEntrega.idendereco &&
        this.formEnderecoEntrega.cep &&
        this.formEnderecoEntrega.cidade &&
        this.formEnderecoEntrega.uf &&
        this.formEnderecoEntrega.rua
      ) {
        this.isLoading = true;
        const data = {
          rua: this.formEnderecoEntrega.rua,
          cidade: this.formEnderecoEntrega.cidade,
          uf: this.formEnderecoEntrega.uf,
          cep: this.formEnderecoEntrega.cep,
          bairro: this.formEnderecoEntrega.bairro
        };
        this.$store
          .dispatch(VENDA_MAIS_COORDENADAS, data)
          .then(data => {
            this.formEnderecoEntrega.lat = data.lat;
            this.formEnderecoEntrega.lng = data.lng;
            this.buscaFormasEntrega();
            this.coordenadasErro = false;
            this.isLoading = false;
          })
          .catch(() => {
            this.coordenadasErro = true;
            this.isLoading = false;
          });
      } else {
        this.formasEntrega = [];
        this.formTotais = {
          formaEntrega: null
        };
        if (this.formEnderecoEntrega.idendereco) {
          this.buscaFormasEntrega();
        }
      }
    },
    buscaFormasEntrega() {
      if (
        (!this.formEnderecoEntrega.cep ||
          !this.formEnderecoEntrega.lat ||
          !this.formEnderecoEntrega.lng) &&
        this.formCabecalho.tipo_entrega === "DELIVERY"
      ) {
        this.$vueOnToast.pop("error", "Falha ao buscar formas de entrega");
        return;
      }
      this.isLoading = true;
      const data = {
        token: `${this.token}${this.tokenSplit}${this.formCabecalho.cliente.idcliente}`,
        idendereco: this.formEnderecoEntrega.idendereco,
        tipoEntrega: this.formCabecalho.tipo_entrega,
        idformapagamento: this.formaPagamentoSelecionada.idformapagto,
        cep: !this.formEnderecoEntrega.idendereco
          ? this.formEnderecoEntrega.cep
          : null,
        lng: !this.formEnderecoEntrega.idendereco
          ? this.formEnderecoEntrega.lng
          : null,
        lat: !this.formEnderecoEntrega.idendereco
          ? this.formEnderecoEntrega.lat
          : null
      };
      this.$store
        .dispatch(VENDA_MAIS_FORMAS_ENTREGA, data)
        .then(data => {
          this.formasEntrega = data.map(f => {
            return {
              ...f,
              label: f.nome,
              value: `${f.idformaentrega}|${f.iddetalhecustotransporte}`
            };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao buscar formas de entrega");
          this.isLoading = false;
        });
    },
    cancelarPedido() {
      this.resetaFormChangeCliente(true, true);
    },
    apagarNovoPedido() {
      this.dialogNovoPedido = false;
      this.novoPedido = null;
    },
    validaCupom(showToast) {
      if (this.formCabecalho.codigocupom) {
        if (this.formCabecalho.cliente) {
          this.isLoading = true;
          const data = {
            codigoCupom: this.formCabecalho.codigocupom,
            idcliente: this.formCabecalho.cliente.idcliente
          };
          this.$store
            .dispatch(VENDA_MAIS_VALIDAR_CUPOM, data)
            .then(validacao => {
              this.isLoading = false;
              if (!validacao) {
                this.formCabecalho.codigocupom = "";
                this.formCabecalho.cupom = null;
                if (showToast) {
                  this.$vueOnToast.pop(
                    "error",
                    "Não foi possível verificar seu cupom"
                  );
                }
                return;
              }
              if (!validacao.valido) {
                this.formCabecalho.codigocupom = "";
                this.formCabecalho.cupom = null;
                if (showToast) {
                  this.$vueOnToast.pop(
                    "error",
                    validacao.error || "Não foi possível verificar seu cupom"
                  );
                }
                return;
              }
              const valorTetoCupom = _.get(validacao, "cupom.valor_teto");
              this.formCabecalho.cupom = {
                idcupomdesconto: _.get(validacao, "cupom.idcupomdesconto", ""),
                valorDescontoPercentual: validacao.percentualDesconto,
                tipoDesconto: _.get(validacao, "cupom.tipodesconto") || "%",
                valorTeto:
                  valorTetoCupom === null || valorTetoCupom === undefined
                    ? null
                    : Number(valorTetoCupom),
                produtosComDesconto:
                  _.get(validacao, "cupom.produtosComDesconto") || [],
                naoUsarCupomComPolitica:
                  _.get(validacao, "cupom.nao_usar_com_politica") || false,
                codigoCupom: _.get(validacao, "cupom.codigocupom", ""),
                totalDescontoEspecifico: 0
              };
              if (showToast) {
                this.$vueOnToast.pop(
                  "success",
                  "Cupom adicionado com sucesso!"
                );

                this.chatsocket.emit("block-cart", true);
                this.chatsocket.emit(
                  "change-cupom",
                  validacao.cupom.codigocupom
                );
              }
              return;
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          this.formCabecalho.cupom = null;
        }
      } else {
        this.formCabecalho.codigocupom = "";
        this.formCabecalho.cupom = null;
      }
    },
    updateProdutoDesconto() {
      if (!this.formProdutos.length) {
        return;
      }

      if (this.formCabecalho.cupom) {
        const {
          tipoDesconto,
          valorDescontoPercentual,
          produtosComDesconto
        } = this.formCabecalho.cupom;

        if (!produtosComDesconto || !produtosComDesconto.length) {
          this.formProdutos = this.formProdutos.map(fp => {
            return { ...fp, preco_do_desconto: 0 };
          });
          return;
        }
        const itensPedido = this.formProdutos;
        const isPercent = tipoDesconto === "%";
        const tetoDesconto = obterTetoDescontoCupom(this.formCabecalho.cupom);
        let novoTotalDescontoEspecifico = 0;
        const produtos = [];

        itensPedido.forEach(i => {
          let valorDesconto = 0;
          const elegivel =
            valorDescontoPercentual &&
            produtosComDesconto.indexOf(i.idcadastroextraproduto) >= 0;

          if (elegivel) {
            const valorDescontoFixo = !isPercent
              ? (valorDescontoPercentual /
                  produtosComDesconto.length /
                  i.quantidade) *
                i.quantidade
              : 0;
            valorDesconto = isPercent
              ? Number(
                  (
                    (valorDescontoPercentual / 100) *
                    (i.precoatendente || i.preco) *
                    i.quantidade
                  ).toFixed(2)
                )
              : Number(valorDescontoFixo.toFixed(6));
            valorDesconto =
              (i.precoatendente || i.preco) <= valorDesconto
                ? i.precoatendente || i.preco
                : valorDesconto;
            novoTotalDescontoEspecifico += valorDesconto;
          }

          produtos.push({ ...i, preco_do_desconto: valorDesconto });
        });

        if (
          isPercent &&
          tetoDesconto &&
          novoTotalDescontoEspecifico > tetoDesconto
        ) {
          const itensElegiveis = produtos
            .filter(produto => produto.preco_do_desconto > 0)
            .map(produto => ({
              idcadastroextraproduto: produto.idcadastroextraproduto,
              preco: produto.precoatendente || produto.preco,
              quantidade: produto.quantidade
            }));
          const resultadoTeto = calcularDescontoPercentualComTetoNasLinhas(
            itensElegiveis,
            valorDescontoPercentual,
            tetoDesconto
          );
          novoTotalDescontoEspecifico = resultadoTeto.totalDesconto;
          produtos.forEach(produto => {
            if (produto.preco_do_desconto > 0) {
              produto.preco_do_desconto =
                resultadoTeto.descontosPorChave.get(
                  produto.idcadastroextraproduto
                ) || 0;
            }
          });
        }

        this.formProdutos = produtos;
        this.formCabecalho.cupom.totalDescontoEspecifico =
          novoTotalDescontoEspecifico;
      } else {
        this.formProdutos = this.formProdutos.map(fp => {
          return { ...fp, preco_do_desconto: 0 };
        });
      }

      return;
    },
    exibirModalEndereco() {
      this.dialogEndereco = true;
    },
    chageDeliveryType(idformaEntrega) {
      const formaDeEntrega = this.formasEntrega.find(
        formEntrega => formEntrega.value === idformaEntrega
      );

      this.chatsocket.emit("block-cart", true);
      this.chatsocket.emit("change-delivery", formaDeEntrega);
    },
    showComponente(modulos = []) {
      if (modulos && modulos.length > 0) {
        return this.moduloFornecedorAtivo(modulos);
      } else {
        return false;
      }
    },
    maskCep(cep) {
      setTimeout(() => {
        this.formEnderecoEntrega.cep =
          cep && "cep" in cep
            ? cep.cep.replace(/[^0-9-]/g, "")
            : this.formEnderecoEntrega.cep.replace(/[^0-9-]/g, "");
      }, 10);

      const numericCep =
        cep && "cep" in cep
          ? cep.cep
          : this.formEnderecoEntrega.cep.replace(/\D/g, "");
      const limitedCep = numericCep.substring(0, 8);
      let formattedCep = null;

      if (numericCep.length > 8) {
        formattedCep = limitedCep;
        this.formatCep(formattedCep, limitedCep);
      } else {
        this.formatCep(formattedCep, limitedCep);
      }
    },
    formatCep(formattedCep, limitedCep) {
      setTimeout(() => {
        formattedCep = limitedCep
          .replace(/\D/g, "")
          .replace(/(\d{5})(\d)/, "$1-$2")
          .replace(/(-\d{3})\d+?$/, "$1");

        this.formEnderecoEntrega.cep = formattedCep;
      }, 10);
    },
    findFormaEntrega(formaEntrega) {
      return (
        this.formasEntrega.find(item => {
          const formaEntregaSemPipe = formaEntrega.split("|");

          return (
            item.idformaentrega === formaEntregaSemPipe[0] &&
            item.iddetalhecustotransporte === formaEntregaSemPipe[1]
          );
        }) || ""
      );
    },
    initConnectionSocket(idcliente) {
      this.chatsocket = io(`${this.socketUrl}/atendimento`);
      this.chatsocket.on("connect", () => {
        this.chatsocket.emit("handshake", {
          idcliente: idcliente,
          idfornecedor: this.getFornecedorId
        });
      });
    }
  },
  mounted() {
    this.getUrlSocket();
    const cpfCliente = this.$route.query.cliente || null;
    this.getCliente(cpfCliente);
    this.sendAcesso();
  }
};
</script>
